export const contactsData = {
    email: 'aliahad002@gmail.com',
    phone: '+923483262649',
    address: 'Jamshoro, Sindh, Pakistan - 76060',

    sheetAPI: ''
}